import React from "react";
import columns from "./AccountingColumns";
import { Link, useParams } from "react-router-dom";

export default function AccountingList({ accounting }) {
  const { tab } = useParams();
  var dateFormat = require("dateformat");

  return (
    <div className="table-responsive" style={{ minHeight: "300px" }}>
      <table className="table">
        <thead style={{ backgroundColor: "#F4F2F2", textAlign: "center" }}>
          <tr>
            {columns.map((column, index) => (
              <>
                {index === 0 ? (
                  <th className="text-left">{column.title}</th>
                ) : (
                  <th className="">{column.title}</th>
                )}
              </>
            ))}

            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {accounting.map((singleData, idx) => (
            <tr>
              {columns.map((column, index) => (
                <Column data={singleData} column={column} index={index} />
              ))}

              {/* <ActionBtns
                                idx = { idx }
                                data = { singleData }
                            /> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  function Column({ data, column, index }) {
    let value = data[column.key];

    if (column?.key == "commission") {
      value =
        (data["order"]["payment_details"]["total_paid"] -
          data["order"]["delivery_details"]["fees"]) *
        0.07;
    } else if (column?.key == "balance") {
      value =
        (data["order"]["payment_details"]["total_paid"] -
          data["order"]["delivery_details"]["fees"]) *
          0.93 +
        data["order"]["delivery_details"]["fees"];
      //  order.delivery_details.fees + (order.payment_details.total_paid - order.delivery_details.fees) * 0.93
    } else if (column?.key == "supplier_commission") {
      value = data["order"]["supplier_commission"] ?? 0;
    } else if (column?.key == "payment_commision") {
      value = data["order"]["payment_commision"] ?? 0;
    } else if (column?.key == "pillvery_commission") {
      value = data["order"]["pillvery_commission"] ?? 0;
    } else if (
      column?.subkey &&
      column?.subkey1 &&
      column?.subkey2 &&
      column?.subkey3
    ) {
      value =
        data[column.key][column.subkey][column?.subkey1][column?.subkey2][
          column?.subkey3
        ] || "__";
    } else if (column?.subkey && column?.subkey1 && column?.subkey2) {
      value =
        data[column.key][column.subkey][column?.subkey1][column?.subkey2] ||
        "__";
    } else if (column?.subkey && column?.subkey1) {
      value = data[column.key][column.subkey][column?.subkey1] || "__";
    } else if (column?.subkey && !column?.subkey1) {
      value = data[column.key][column.subkey] || "__";
    }

    if (column?.float) {
      return (
        <td className="py-1 text-center">
          {value != "__" ? parseFloat(value || 0).toFixed(3) : "__"}
        </td>
      );
    }

    if (column.is_cash && value) {
      return (
        <td className="py-1 text-center">
          {data?.order?.is_cliq
            ? "CliQ"
            : data?.order?.payment_details?.is_cash === true
            ? data?.order?.is_card_on_delivery
              ? `Card on ${data?.order?.order_flow}`
              : `Cash on ${data?.order?.order_flow}`
            : "In-App/Online Payment"}
        </td>
      );
    }

    if (column.date && value) {
      return <td>{dateFormat(value, "dd mmm yyyy - h:MM TT") || "__"}</td>;
    }

    if (column.flag) {
      return (
        <td className="py-1 text-center">
          <span
            className="mdi mdi-brightness-1"
            style={value ? { color: "#2bc0b1" } : { color: "red" }}
          ></span>
        </td>
      );
    }

    if (column.is_jod) {
      return <td className="py-1 text-center">{value || "__"}</td>;
    }

    if (column.is_cash) {
      return (
        <td className="py-1 text-center">
          {data?.order?.is_cliq
            ? "CliQ"
            : data?.order?.payment_details?.is_cash === true
            ? data?.order?.is_card_on_delivery
              ? `Card on ${data?.order?.order_flow}`
              : `Cash on ${data?.order?.order_flow}`
            : "In-App/Online Payment"}
        </td>
      );
    }

    if (index === 0) {
      return <td className="text-left">{value || "__"}</td>;
    }
    if (column?.subkey == "status") {
      return <td className="text-capitalize">{value.replace(/_/g, " ")}</td>;
    }

    return <td>{value || "__"}</td>;
  }

  function ActionBtns({ idx, data }) {
    if (tab == "pending") {
      return (
        <>
          <td>
            <div className="dropdown dropright card-menu-dropdown">
              <button
                className="btn"
                type="button"
                id="cardMenuButton6"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="mdi mdi-dots-horizontal card-menu-btn"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="cardMenuButton6">
                <Link className="dropdown-item" onClick={() => null}>
                  Test
                </Link>
              </div>
            </div>
          </td>
        </>
      );
    }

    return null;
  }
}
